// extracted by mini-css-extract-plugin
export var body = "styles-module--body--8TSzz";
export var contact = "styles-module--contact--8Z01Z";
export var contactItem = "styles-module--contact-item--G9n5z";
export var contactsContainer = "styles-module--contacts-container--Na6+b";